<template>
  <div id="double-image-hero" :style="[{backgroundImage: bgPhoto}, {backgroundPositionY: bgPosition}]">
    <!--<div id="video-banner-overlay">
      <video v-if="images.videoLink.length > 0" autoplay="true" class="hidden-xs" id="homepage-background-video" loop="true" muted="true">
        <source class="ajax-video" :src="images.videoLink" type="video/mp4">
      </video>
    </div>-->
    <div class="hero-overlay">
      <div class="cta-image-box">
        <h3>New {{ new Date().getFullYear() }} {{brandName}}</h3>
        <h2 class="uppercase">{{vehicleType}}</h2>
        <h1 class="uppercase">0% APR</h1>
        <h3 class="bigger">for 36 mos</h3>
        <a class="btn hp-cta-btn" href="#">Shop Now</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    bgPhoto () {
      if (this.brand === 'chevrolet' || this.brand === 'hyundai' || this.brand === 'infiniti' || this.brand === 'lincoln' || this.brand === 'nissan' || this.brand === 'toyota') {
        return 'url(' + this.images.lifestyleImages.sedanImage + ')';
      } else if (this.brand === 'none' || this.brand === 'mazda' || this.brand === 'mitsubishi' || this.brand === 'cjdr') {
        return 'url(' + this.images.lifestyleImages.suvImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      }
    },
    vehicleType () {
      if (this.brand === 'chevrolet' || this.brand === 'hyundai' || this.brand === 'infiniti' || this.brand === 'lincoln' || this.brand === 'nissan' || this.brand === 'toyota' || this.brand === 'honda') {
        return this.images.sedans[0].modelName;
      } else if (this.brand === 'none' || this.brand === 'cjdr') {
        return 'SUVs & Crossovers';
      } else {
        return this.images.suvs[0].modelName;
      }
    },
    bgPosition () {
      if (this.brand === 'kia') {
        return '40%';
      } else if (this.brand === 'mazda' || this.brand === 'toyota') {
        return '60%';
      } else if (this.brand === 'mitsubishi') {
        return '70%';
      } else {
        return '50%';
      }
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  #double-image-hero {
    margin: auto;
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-position-y: 50%;
  }
  #double-image-hero .hero-overlay {
    min-height: 50vh;
    padding-top: 3%;
    padding-bottom: 3%;
    padding-left: 10%;
    padding-right: 15px;
    background-color: rgba(0,0,0,0);
    z-index: 10;
    position: relative;
    display: flex;
    align-items: center;
  }
  #video-banner-overlay {
    position: relative;
    z-index: 0;
  }
  video#homepage-background-video {
    position: absolute;
    left: 0;
    right: 0;
    min-height: 100%;
    width: 100%;
    height: auto;
    z-index: 0;
    background-size: cover;
  }
  #double-image-hero .cta-image-box {
    margin: 0px;
    background: rgba(255,255,255,0.95);
    padding: 30px;
    text-align: center;
    border-radius: 12px;
    display: inline-block;
  }
  #double-image-hero .cta-image-box h3 {
    margin: 0px auto 5px;
  }
  #double-image-hero .cta-image-box h2 {
    margin-top: 0;
    font-size: 2.5rem;
  }
  #double-image-hero .cta-image-box .uppercase {
    text-transform: uppercase;
    font-weight: 600;
  }
  #double-image-hero .cta-image-box .bigger {
    font-size: 2.8rem;
  }
  #double-image-hero .cta-image-box h1 {
    font-size: 5rem;
    margin-top: 30px;
    margin-bottom: 5px;
  }
  #double-image-hero .hp-cta-btn {
    background: var(--primary-color);
    border: 2px solid var(--primary-color);
    color: #fff;
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 500;
    border-radius: 4px;
    margin: 45px auto auto;
    padding: 10px;
    display: block;
    max-width: 300px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
  }
  #double-image-hero .hp-cta-btn:hover, #double-image-hero .hp-cta-btn:active, #double-image-hero .hp-cta-btn:focus {
    background: rgba(0,0,0,0);
    color: var(--primary-color);
    box-shadow: none;
  }

  @media(max-width: 1199px) {
    #double-image-hero .hero-overlay {
      padding-top: 4%;
      padding-bottom: 4%;
    }
  }

  @media(max-width: 991px) {
    #double-image-hero .cta-image-box {
      margin: auto;
    }
    #double-image-hero .hero-overlay {
      padding-left: 30px;
      padding-top: 6%;
      padding-bottom: 6%;
    }
  }

  @media(min-width: 768px) {
    #double-image-hero .cta-image-box {
      max-width: 50%;
    }
  }

  @media(max-width: 767px) {
    #double-image-hero .cta-image-box {
      padding: 30px 15px;
    }
    #double-image-hero .hero-overlay {
      min-height: 60vh;
      padding-left: 15px;
      padding-top: 50px;
      padding-bottom: 50px;
      text-align: center;
    }
    #double-image-hero .cta-image-box h1 {
      font-size: 5rem;
      margin-top: 20px;
    }
    #double-image-hero .cta-image-box h2 {
      font-size: 2.5rem;
    }
  }
</style>